module.exports = __webpack_public_path__ + "img/paragraph-2.d096742b.svg";